import { Milestone, ServicePayment } from "../../../../../../types/service.type";
import {
  MilestoneStatusEnum,
  ServiceContractStatusEnum,
  ServiceRequestTypeEnum,
} from "../../../../../../enum/service.enum";

/**
 * Calculates the milestone price based on contract type
 */
export const calculateMilestonePrice = (
  paymentConfig: ServicePayment,
  contractType: ServiceRequestTypeEnum,
  milestonesCount: number
): string => {
  const { amount, currency } = paymentConfig;

  if (contractType === ServiceRequestTypeEnum.Fixed) {
    return `${(amount / milestonesCount / 100).toFixed(0)} ${currency}`;
  }

  return `${(amount / 100).toFixed(0)} ${currency}`;
};

/**
 * Calculates the active step index for the stepper
 */
export const calculateActiveStepIndex = (milestones: Milestone[]): number => {
  const isAllMilestonesPaid = milestones.every((milestone) => milestone.status === MilestoneStatusEnum.Paid);

  if (isAllMilestonesPaid) {
    return milestones.length;
  }

  return milestones.findIndex((milestone) => milestone.status === MilestoneStatusEnum.Pinning);
};

/**
 * Checks if a milestone is canceled
 */
export const isMilestoneCanceled = (
  milestoneStatus: MilestoneStatusEnum,
  contractStatus: ServiceContractStatusEnum
): boolean => {
  return milestoneStatus !== MilestoneStatusEnum.Paid && contractStatus === ServiceContractStatusEnum.CanceledAfterPaid;
};

/**
 * Calculates the border style for step content
 */
export const getMilestoneBorderStyle = (isLast: boolean, isPinning: boolean, isPaid: boolean): string => {
  if (isLast) {
    return "none";
  }

  if (isPinning || isPaid) {
    return "2px solid var(--Green---100, #008B07)";
  }

  return "2px solid var(--Gray-200, #EAECF0)";
};
